export const authFunctions ={
    passwordReset: "passwordReset",
    autoLogin: "autoLogin"
}

export const authStates = {
    signedIn: "signedIn",
    loggedOut: "loggedOut",
    refreshingToken: "refreshingToken"
}